export const enum ViewIndex {
    COLORS = "COLORS",
    TYPOGRAPHY = "TYPOGRAPHY",
    FORMS = "FORMS",
    INPUTS = "INPUTS",
    BUTTONS = "BUTTONS",
    TABLES = "TABLES",
    FORM_FIELDS = "FORM_FIELDS",
    FORM_PAGE = "FORM_PAGE",
}
